import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { thrash } from '../../assets/svg/other'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal/Modal'
import Table from '../../components/Table'
import { getFormOfEducation, deleteFormOfEducation } from '../../actions/directory'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { getCanteenStaffList, deleteCanteenStaff } from '../../actions/directoryCanteen'
import { getUsefulSitesList } from '../../actions/useful_sites'
import { Checkbox, Input, Select, Textarea } from '../../components/ModalInputs'
import moment from 'moment'
import { getDocumentJournalList } from '../../actions/documents_journal'
import { createIntegration } from '../../actions/unloading_integration_SVO'

const dateFormat = 'YYYY-MM-DD'; // Тип даты
const defaultDate = { begin_date: moment(new Date()).format(dateFormat), end_date: moment(new Date()).format(dateFormat) }; // Дата по умолчанию
const PARALLELS = [
  { title: 'Передача данных по учебной структуре', name: 'educational_structure', ind: 1 },
  { title: 'Передача данных по постоянному составу', name: 'personal_staff', ind: 2 },
  { title: 'Передача данных по обучающимся', name: 'student', ind: 3 },
  { title: 'Передача сведений об успеваемости', name: 'grades', ind: 4 },
  { title: 'Передача сведений об учебных занятиях по расписанию', name: 'timetable', ind: 5 },
  { title: 'Передача сведений об учебно-материальной базе', name: 'edu_base', ind: 6 },
]


export default function UnloadingIntegrationSVO() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { usefulSiteslist } = useSelector(state => state.useful_sites)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);
  const [date, setDate] = useState(defaultDate); // Дата для поиска

  const [parallels, setParallels] = useState([])
  const [all, setAll] = useState(false)




  const openModal = (data) => () => {

    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const goHome = () => navigate('/')

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteCanteenStaff(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { picture, title, text, link, sid } = data
    return (
      <tr >
        <td onClick={openModal(data)}>{picture}</td>
        <td onClick={openModal(data)}>{title}</td>
        <td onClick={openModal(data)}>{text}</td>
        <td onClick={openModal(data)}>{link}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ sid, title })}><BiTrash /></i></td>
      </tr>
    )
  }

  const dateChangeHandler = (name, value) => { // Обработчик изменения дат
    setDate({ ...date, [name]: moment(value).format(dateFormat) });
  }

  const refresh = () => {
    dispatch(getDocumentJournalList(date))
  }
  const handleChangeCheck = (e) => {
    const item = e.target.value
    if (parallels?.find(el => el === +e.target.value)) {
      setParallels(parallels.filter((el, i) => parallels.indexOf(+e.target.value) !== i))
    } else if (item == 'all') {
      if (!all) {
        setParallels([1, 2, 3, 4, 5, 6])
        setAll(true)
      } else {
        setAll(false)
        setParallels([])
      }
    }
    else { setParallels((prev) => prev ? [...prev, +e.target.value] : +e.target.value) }
  }


  const createInteg = (name) => {
    const selectedItems = PARALLELS.filter(el => parallels.includes(el.ind)).map(el => ({ [el.name]: true }))
    const result = Object.assign({}, ...selectedItems);


    const body = { ...result, name: name, begin_date: moment(date.begin_date).format('DD.MM.YYYY'), end_date: moment(date.end_date).format('DD.MM.YYYY') }
    dispatch(createIntegration(body))
    closeModal();
  }

  return (
    <div className={styles.wrapper} style={{ width: '1200px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          // intName={intName}
          // setIntName={setIntName}
          createInteg={createInteg}
        />
      }
      <h1>Выгрузка интеграции СВО</h1>
      <div className={styles.inputsRow}>
        <span className={styles.label}>Период:</span>
        <Input type='date' value={date.begin_date} onChange={(e) => dateChangeHandler('begin_date', e.target.value)} />
        <Input type='date' value={date.end_date} onChange={(e) => dateChangeHandler('end_date', e.target.value)} />
      </div>


      <div className={styles.inputsColumn}>
        <p>Состав данных для экспорта</p>
        <div className={styles.checkboxArea}>
          <Checkbox
            label='Выбрать все'
            // checked={!!parallels?.find(el => el === 'all')}
            value='all'
            onChange={(e) => handleChangeCheck(e)}
            name='parallels'
          // disabled={disabledList2?.find(el => el == par)}
          />
          {PARALLELS?.map(par => {
            const che = parallels?.find(el => +par.ind == +el)
            return (
              <Checkbox
                label={par.title}
                checked={!!che}
                value={par.ind}
                onChange={(e) => handleChangeCheck(e)}
                name='parallels'
              // disabled={disabledList2?.find(el => el == par)}
              />
            )
          }
          )}
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: "row" }}>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={openModal()}
        >
          <IoIosAdd size={30} />
          Создать
        </Button>
      </div>
    </div>
  )
}
